// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LLhV","col":"styles_col__2jLuI"};